import { Block, Button, SvgIcon, Typography, palette, spacing, useBreakpoints } from "@stepapp/ui";
import { useRouter } from "expo-router";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { useCanGoBack } from "../hooks";

type ErrorPageProps = {
  title?: string;
  description?: string;
  onClick?: () => void;
};

const ErrorPage = ({ title, description, onClick }: ErrorPageProps) => {
  const { md } = useBreakpoints();
  const { t } = useTranslation();
  const { back, navigate } = useRouter();
  const canGoBack = useCanGoBack();

  const handleGoBack = useCallback(() => {
    if (onClick) {
      return onClick();
    }
    if (!canGoBack) {
      return navigate("/");
    }

    back();
  }, [back, canGoBack, navigate, onClick]);

  return (
    <Block alignCenter row={md} style={styles.container}>
      {md && (
        <Block alignCenter marginBottom={6} marginTop={4} width={50}>
          <SvgIcon color={palette.primary.accent} name="stepappLogo" size={40} />
        </Block>
      )}

      <Block flex={1} marginTop={md ? 0 : 10}>
        <Typography center={!md} variant="newH2">
          {title}
        </Typography>

        <Block paddingTop={4}>
          <Typography center={!md} variant="body">
            {description}
          </Typography>

          <Block alignStart={md} marginBottom={2} marginTop={4}>
            <Button
              label={t("common.goBack")}
              onPress={handleGoBack}
              style={md && { width: spacing.unit * 20 }}
              type="primary"
            />
          </Block>
        </Block>
      </Block>
    </Block>
  );
};

export default React.memo(ErrorPage);

const styles = StyleSheet.create({
  container: {
    minHeight: "100%",
  },
});
